import { uploadImageByBase64 } from '../uploadImageByBase64/uploadImageByBase64'

export async function uploadImageByUrl(imageUrl: string, signal?: AbortSignal) {
  if (!imageUrl) {
    return { id: null, urlTemporary: null }
  }

  const response = await fetch(
    `/api/images/get-base64?url=${encodeURI(imageUrl)}`,
    {
      signal,
    }
  )

  const { data } = await response.json()
  return await uploadImageByBase64(data)
}
